import type { Industry } from '../../../../types';
import styles from './IndustrySidebar.module.css';

interface IndustrySidebarProps {
  industries: Industry[];
  active: string;
  /** Total product count, shown against "All Products". */
  allCount: number;
  /** `''` selects "All Products"; otherwise an industry code. */
  onSelect: (code: string) => void;
}

export function IndustrySidebar({ industries, active, allCount, onSelect }: IndustrySidebarProps) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.heading}>Industries</div>

      <button
        type={'button'}
        className={`${styles.item} ${active === '' ? styles.itemActive : ''}`}
        onClick={() => onSelect('')}
      >
        <span className={styles.label}>All Products</span>
        <span className={styles.count}>{allCount}</span>
      </button>

      {industries.map((ind) => (
        <button
          key={ind.code}
          type={'button'}
          className={`${styles.item} ${active === ind.code ? styles.itemActive : ''}`}
          onClick={() => onSelect(ind.code)}
        >
          <span className={styles.label}>{ind.display_name}</span>
          <span className={styles.count}>{ind.products.length}</span>
        </button>
      ))}
    </aside>
  );
}
